var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('LinkdeConviteNew',{attrs:{"shareInfo":_vm.shareInfo}}):_c('LinkdeConvite',{attrs:{"shareInfo":_vm.shareInfo}})
}
var staticRenderFns = []

export { render, staticRenderFns }